import Grid from './Grid.html'

Array.from(document.querySelectorAll(`product_grid`)).forEach(target => new Grid({
	target,
	data: target.dataset,
}))
